import getCurrencyPriceByCoins from './getCurrencyPriceByCoins';

function getCurrencyPriceByCoinsWoCents(coins = 0, currency, options) {
  const price = getCurrencyPriceByCoins(coins, currency, options);

  return price.slice(0, -3);
}

export default getCurrencyPriceByCoinsWoCents;
